import {Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {I18nService} from '../../../_services/gui/i18n.service';
import {RequiredComponent} from '../required/required.component';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../validation-errors/validation-errors.component';
import {NgxMaskModule} from 'ngx-mask';
import {KeyValuePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    imports: [ReactiveFormsModule, RequiredComponent, ValidationErrorsComponent_1, NgxMaskModule, KeyValuePipe, TranslateModule]
})
export class AddressFormComponent implements OnInit {

  @Output('formGroup') output: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();

  @Input() formGroup: UntypedFormGroup;

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  @Input() displayErrors: boolean = false;

  provinceNames: Map<string, string>;
  private i18nService = inject(I18nService);
  private formBuilder = inject(UntypedFormBuilder);

  constructor() {
    const i18nService = this.i18nService;

    i18nService.provinceNames.subscribe(value => this.provinceNames = value);
  }

  ngOnInit() {
    if(!this.formGroup) {
      this.formGroup = this.formBuilder.group({
        streetNum:    '',
        street:       ['', Validators.required],
        apartmentNum: '',
        city:         ['', Validators.required],
        province:     ['', Validators.required],
        postalCode:   ['', Validators.required]
      });
    }
    this.output.emit(this.formGroup);
  }

  public get c(): {[p: string]: AbstractControl} {
    return this.formGroup.controls;
  }

}
